export const Types = {
    LOAD_FORECASTING_DATA: "LOAD_FORECASTING_DATA",
};